export interface ForgotRequest {
    username: string;
}

export interface ForgotResponse {
    message: string;
  }

  export const InitForgotRequest: ForgotRequest = { username: "" }